import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { class: "input-block" }
const _hoisted_3 = { class: "input-block" }
const _hoisted_4 = { class: "input-block keep-login" }
const _hoisted_5 = { class: "login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block-label" }, "ユーザーID", -1)),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["form-control", _ctx.invalidClass]),
          onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
          type: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginReq.name) = $event)),
          autocomplete: "email",
          autofocus: ""
        }, null, 34), [
          [_vModelText, _ctx.loginReq.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block-label" }, "パスワード", -1)),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["form-control", _ctx.invalidClass]),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
          type: "password",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginReq.password) = $event)),
          autocomplete: "current-password"
        }, null, 34), [
          [_vModelText, _ctx.loginReq.password]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loginReq.rememberMe) = $event)),
          id: "keepLoginCheckbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.loginReq.rememberMe]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "keepLoginCheckbox" }, "ログイン情報を保存する", -1))
      ]),
      _createElementVNode("div", {
        class: "invalid-text",
        style: _normalizeStyle([{"text-align":"center","padding-bottom":"20px"}, {'visibility': _ctx.failedToLogin?'visible':'hidden'}])
      }, " ユーザIDもしくはパスワードが一致しませんでした。 ", 4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)))
        }, "ログイン")
      ])
    ])
  ]))
}